import {
  Table,
  TableBody,
  TableContainer,
  TableRow,
  TableCell,
} from "@mui/material";

export default function TableComponentForReport({
  headers,
  rows,
  description,
  numbered,
  bordered,
  smallText,
}) {
  return (
    <div className="flex flex-col">
      {description && (
        <label className="report_little_text">{description}</label>
      )}
      <TableContainer
        sx={{
          overflowY: "auto",
          "@media print": {
            overflowX: "hidden !important",
          },
        }}
      >
        <Table
          sx={{
            maxWidth: "100%",
            border: bordered ? "1px solid black" : undefined,
            width: "100%",
            tableLayout: "auto",
            "@media print": {
              width: "100%",
              tableLayout: "fixed !important",
            },
          }}
          aria-label="simple table"
          size="small"
        >
          <TableBody>
            <TableRow
              key={0}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              {numbered && (
                <TableCell
                  key={Math.random()}
                  component="th"
                  scope="row"
                  sx={{
                    "@media print": {
                      width: "1%",
                    },
                  }}
                >
                  <b className="app_text_color centeredText">
                    <label
                      className={`${
                        smallText ? "report_small_text" : "report_little_text"
                      } textAlignedCenter`}
                    >
                      #
                    </label>
                  </b>
                </TableCell>
              )}

              {headers.map((header) => (
                <TableCell key={Math.random()} component="th" scope="row">
                  <b className="app_text_color centeredText">
                    <label
                      className={`${
                        smallText ? "report_small_text" : "report_little_text"
                      } textAlignedCenter`}
                    >
                      {header}
                    </label>
                  </b>
                </TableCell>
              ))}
            </TableRow>

            {rows?.map((row, index) => (
              <TableRow
                key={Math.random()}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {numbered && (
                  <TableCell
                    key={Math.random()}
                    sx={{
                      "@media print": {
                        width: "1%",
                      },
                    }}
                  >
                    <label
                      className={`${
                        smallText ? "report_small_text" : "report_little_text"
                      } centeredText`}
                    >
                      {index + 1}
                    </label>
                  </TableCell>
                )}
                {row?.map((value) => (
                  <TableCell key={Math.random()}>
                    <label
                      className={`${
                        smallText ? "report_small_text" : "report_little_text"
                      } centeredText`}
                    >
                      {value}
                    </label>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
